import { render, staticRenderFns } from "./not-found-container.vue?vue&type=template&id=64204882"
import script from "./not-found-container.vue?vue&type=script&lang=js"
export * from "./not-found-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64204882')) {
      api.createRecord('64204882', component.options)
    } else {
      api.reload('64204882', component.options)
    }
    module.hot.accept("./not-found-container.vue?vue&type=template&id=64204882", function () {
      api.rerender('64204882', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/404/components/not-found-container.vue"
export default component.exports